import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/AuthProvider";
import { PATH_PAGE } from "./Paths";

const isAuthenticated = (User) => User?.token || false;

export const PrivateRouteMentor = ({ path, element }) => {
  const { user } = useContext(AuthContext);
  return isAuthenticated(user) && user?.data?.type === "mentor" ? (
    <Outlet />
  ) : (
    <Navigate to={PATH_PAGE.login} />
  );
};

export const PrivateRouteClient = ({ path, element }) => {
  const { user } = useContext(AuthContext);
  return isAuthenticated(user) && user?.data?.type === "client" ? (
    <Outlet />
  ) : (
    <Navigate to={PATH_PAGE.UserLogin} />
  );
};

export const AuthPublicRoutes = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  /** Mentor SSO / magic-link: must mount Login to refresh token + localStorage even if already logged in */
  const mentorSessionHandoff =
    location.pathname === PATH_PAGE.login &&
    Boolean(
      search.get("id") && search.get("slug") && search.get("token"),
    );

  if (!isAuthenticated(user)) {
    return <Outlet />;
  }

  if (mentorSessionHandoff) {
    return <Outlet />;
  }

  return user?.data?.type === "mentor" ? (
    <Navigate to={PATH_PAGE.dashboard} />
  ) : (
    <Navigate to={PATH_PAGE.clHome} />
  );
};
